import textResource from '../resources/textResource.json';


export default textResource;